module.exports = __webpack_public_path__ + "static/img/good1.e268f8c8.png";